import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from './analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page name from pathname
    const pageName = location.pathname === '/' ? 'home' : location.pathname.slice(1);
    
    // Get page title
    const pageTitle = document.title;

    // Track page view
    analytics.pageView(pageName, pageTitle, window.location.href);
  }, [location]);
}; 